import { Api } from './api';
import { message } from 'antd';

export async function createUser(username, password, admin, successCallback) {
    return await Api.createUser(username, password, admin).then((res) => {
        if (res === 1) {
            message.error(
                'The provided username already exists in the system.\n Please provide a different username.',
                10
            );
        } else {
            successCallback();
            message.success('Your account has been created. \n Now you can log in using your account ', 10);
        }
    });
}